import { render, staticRenderFns } from "./BtnBack.vue?vue&type=template&id=89a7679a&scoped=true&"
import script from "./BtnBack.vue?vue&type=script&lang=js&"
export * from "./BtnBack.vue?vue&type=script&lang=js&"
import style0 from "./BtnBack.vue?vue&type=style&index=0&id=89a7679a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a7679a",
  null
  
)

export default component.exports